type ExperimentParameters = Record<string, string>;
export type ExperimentDefinition = readonly [string, ExperimentParameters];
export type ExperimentDefinitions = Record<string, ExperimentDefinition>;

export const ExperimentLayers = {
  Measures: [
    'telehealth_measures',
    {
      ShouldShowClientMeasures: 'shouldShowClientMeasures',
      ShouldShowProviderMeasures: 'shouldShowProviderMeasures',
    },
  ],
  PruneGraceMultiplier: [
    'telehealth_prune_grace_multiplier_experiment',
    {
      pruneGraceMultiplier: 'pruneGraceMultiplier',
    },
  ],
  Admission: [
    'telehealth_admission',
    {
      automaticAdmissionIsEnabled: 'automaticAdmissionIsEnabled',
      systemNotificationsAreEnabled: 'systemNotificationsAreEnabled',
    },
  ],
  FollowUpScheduling: [
    'follow_up_scheduling',
    {
      shouldSeeIntakeNudge: 'shouldSeeIntakeNudge',
      shouldSeeWaitingRoomScheduleCta: 'shouldSeeWaitingRoomScheduleCta',
    },
  ],
  ShowSessionRecapInTelehealth: [
    'show_session_recap_in_telehealth',
    {
      showSessionRecap: 'show_session_recap',
    },
  ],
} as const satisfies ExperimentDefinitions;
